




import {Vue, Component} from 'vue-property-decorator'

import Contact  from '@/components/Contact.vue'

@Component({
  components: {
      Contact
  }
})
export default class ContactView extends Vue {

}
